import { useEffect, useState } from "react";
// @mui
import {
  Button,
  MenuItem,
  Container,
  Grid,
  Typography,
  InputLabel,
  FormControl,
  Box,
  TextField,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import Select from "@mui/material/Select";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";

// ----------------------------------------------------------------------

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1, paddingTop: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
const defaultState = {
  title_en: "",
  title_fr: "",
};
export default function PickemDialog(props) {
  const [pickem, setPickem] = useState(defaultState);

  const handleChange = (e) => {
    const { id, value } = e.target;

    setPickem((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const [value, setValue] = useState(0);

  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };
  const onSuccess = () => {
    setPickem(defaultState);
    props.onSuccessHandler(pickem);
  };
  const onCancel = () => {
    setPickem(defaultState);
    props.onClose();
  };
  //console.log(option);
  return (
    <>
      <Dialog
        open={props.open}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Create Pickem</DialogTitle>
        <DialogContent>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
              >
                <Tab label="English" {...a11yProps(0)} />
                <Tab label="French" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <TextField
                id="title_en"
                label="Title"
                fullWidth
                value={pickem.title_en}
                variant="standard"
                onChange={handleChange}
              />
            </TabPanel>

            <TabPanel value={value} index={1}>
              <TextField
                id="title_fr"
                label="Title"
                fullWidth
                value={pickem.title_fr}
                variant="standard"
                onChange={handleChange}
              />
            </TabPanel>
          </Box>
          <Box sx={{ width: "100%" }}></Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onCancel()}>Cancel</Button>
          <Button onClick={() => onSuccess()} autoFocus>
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
